<template>
  <Card
    :padding="false"
    :margins="false"
  >
    <template slot="header">
      {{ person.firstName }} {{ person.lastName }} ({{ person.personID }})<br>
      Available Credit: ${{ person.baxterBucks }}
    </template>
    <v-list>
      <!-- user links -->
      <template v-for="item in items">
        <v-list-tile
          v-if="item.visible(item)"
          :key="item.text"
          :to="item.path">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <!--logout -->
      <v-list-tile
        v-if="proxyPerson"
        @click="unloadProxyPerson()">
        <v-list-tile-action>
          <v-icon>fa-check-square</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Done with user
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        @click="logoutAndRedirect()"
      >
        <v-list-tile-action>
          <v-icon>fa-sign-out-alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Log Out
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </Card>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data () {
    return {
      items: [
        {
          icon: 'fa-qrcode',
          text: 'Check In',
          path: '/checkin',
          visible: () => this.assertSetting('miscScanCode', 1)
        },
        {
          icon: 'beenhere',
          text: 'Make a Reservation',
          path: '/reserve',
          visible: () => true
        },
        {
          icon: 'view_week',
          text: 'Reservation Viewer',
          path: '/reservations',
          visible: () => true
        },
        {
          icon: 'fa-file-invoice-dollar',
          text: 'Invoices',
          path: '/invoices',
          visible: () => true
        },
        {
          icon: 'account_circle',
          text: 'Profile',
          path: '/person/profile',
          visible: () => true
        },
        {
          icon: 'fa-user-plus',
          text: 'New User',
          path: '/signin/signup',
          visible: () => {
            if (this.proxyPerson) {
              return this.assertSetting('personCreate', 1)
            }
            return this.assertSetting('personCreate', 1)
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      person: 'person/person',
      primaryPerson: 'person/primaryPerson',
      proxyPerson: 'person/proxyPerson'
    })
  },
  methods: {
    ...mapMutations({
      logout: 'logout'
    }),
    ...mapActions({
      refreshBaxterBucks: 'person/refreshBaxterBucks',
      loadFacilities: 'facilities/loadFacilities',
      getPersonSettings: 'person/getPersonSettings',
      unloadProxyPerson: 'person/unloadProxyPerson'
    }),
    logoutAndRedirect () {
      this.logout()
      this.$router.push('/')
      this.loadFacilities()
      this.getPersonSettings()
    }
  }
}
</script>
